module.exports = __webpack_public_path__ + "img/desktop_dark.29677f30.svg";